import React from "react";
import Bus from "../utils/bus";
let BUS = new Bus();
// import Youtube from "react-youtube";
import ReactPlayer from "react-player";

const youtubeRe = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVideoOpen: false,
      video: null
    };
    this.renderVideo = this.renderVideo.bind(this);
    this.prepVideo = this.prepVideo.bind(this);
    this.close = this.close.bind(this);
    this.vidReady = this.vidReady.bind(this);
  }

  componentDidMount() {
    BUS.listen("OPEN_VIDEO_MODAL", this.prepVideo);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ isVideoOpen: false });
    }
  }

  close() {
    this.setState({ isVideoOpen: false });
  }

  prepVideo(event) {
    this.setState({ isVideoOpen: true, video: event.detail.url });
  }

  vidReady() {}

  renderVideo() {
    let ratio = 1 - this.state.video.height / this.state.video.width - 0.044;
    let h = 1 - this.state.video.height / this.state.video.width;
    return (
      <div
        className="HeroVideo"
        ref={el => {
          this.el = el;
        }}
      >
        <div className="bg" onClick={this.close} />
        <div className="player">
          <ReactPlayer
            ref={el => {
              this.player = el;
            }}
            url={this.state.video}
            playing={true}
            volume={1}
            muted={false}
            controls={true}
            playsinline={true}
            width="100%"
            height="100%"
            onReady={this.vidReady}
            config={{
              youtube: {
                playerVars: {
                  autoplay: 1,
                  modestbranding: 1,
                  playsinline: 1,
                  rel: 0
                }
              }
            }}
          />
        </div>
        <button className="close" onClick={this.close}>
          <span>&times;</span>
        </button>
      </div>
    );
  }

  render() {
    if (!this.state.isVideoOpen) {
      return null;
    } else {
      return this.renderVideo();
    }
  }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/video.js